document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-search-toggle]');
  const panel = document.getElementById('AtelierSearch');
  if (button && panel) {
    const close = () => { panel.hidden = true; button.setAttribute('aria-expanded', 'false'); };
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input').focus();
    });
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); button.focus(); }
    });
  }
});

// Open WhatsApp directly from the user gesture, outside embedded theme previews.
document.addEventListener('click', function(event) {
  const link = event.target.closest('a.liefha-whatsapp');
  if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.open(link.href, '_blank', 'noopener,noreferrer');
}, true);
